<template>
  <div ref="pano" id="pano"></div>
</template>

<script>
export default {
  props: {
    xml: {
      type: String,
      default: "",
    },
  },
  watch: {
    xml(xml) {
      if (xml && window.krpano) {
        window.krpano.call(
          `
            loadpano(${this.xml}, null, MERGE, BLEND(1.1, easeInCubic));
            loadscene(get(scene[0].name), null, MERGE, BLEND(1);
            // delayedcall(0.6, loadscene(get(scene[0].name), null, MERGE, BLEND(1)))
          `
        );

        // window.krpano.call(
        //   `loadpano(${this.xml}, null, MERGE, BLEND(1.0, easeInCubic));`
        // );
        // window.krpano.call(
        //   `delayedcall(1, loadscene(get(scene[0].name), null, MERGE, BLEND(1)))`
        // );
      }
    },
  },
  mounted() {
    this.initPano();
  },
  beforeUnmount() {
    window.krpano = null;
  },
  methods: {
    initPano() {
      if (!window.embedpano || window.krpano || !this.$refs.pano) return;
      // onxmlcomplete
      window.embedpano({
        bgcolor: "#3d3d3d",
        xml: this.xml,
        target: "pano",
        html5: "prefer",
        mobilescale: 0.5,
        passQueryParameters: true,
        onready: async (krpano) => {
          krpano.hooks = {
            onNotFound: this.showNotFound,
          };
          this.$emit("ready", krpano.get("scene").getArray());
          window.krpano = krpano;
          window.dispatchEvent(new Event("krpanoReady"));
        },
      });
    },
    showNotFound(errorTitle) {
      errorTitle && (this.errorTitle = errorTitle);
      this.errorVisible = true;
    },
  },
};
</script>
